import slugify from 'slugify';

export const routes = {
  masterclass: {
    makeUrl: (masterclassDocumentId: string, masterclassName: string) => {
      const masterclass = slugify(masterclassName, { lower: true, strict: true });
      return `${process.env.NEXT_PUBLIC_FRONT_END_HOST}/masterclass/${masterclass}/${masterclassDocumentId}`;
    },
  },
  seriesDetails: {
    makeUrl: (serieDocumentId: string, serieName: string) => {
      const serie = slugify(serieName, { lower: true, strict: true });
      return `${process.env.NEXT_PUBLIC_FRONT_END_HOST}/serie/${serie}/${serieDocumentId}`;
    },
  },
  learningPathDetails: {
    makeUrl: (learningPathDocumentId: string, learningPathName: string) => {
      const learningPath = slugify(learningPathName, { lower: true, strict: true });
      return `${process.env.NEXT_PUBLIC_FRONT_END_HOST}/percorsi/${learningPath}/${learningPathDocumentId}`;
    },
  },
  learningPathLesson: {
    makeUrl: (
      learningPathDocumentId: string,
      learningPathName: string,
      lessonName: string,
      lessonDocumentId: string,
    ) => {
      const learningPath = slugify(learningPathName, { lower: true, strict: true });
      const lesson = slugify(lessonName, { lower: true, strict: true });
      return `${process.env.NEXT_PUBLIC_FRONT_END_HOST}/percorsi/${learningPath}/${learningPathDocumentId}/${lesson}/${lessonDocumentId}`;
    },
  },
  serieLesson: {
    makeUrl: (
      serieDocumentId: string,
      serieName: string,
      lessonName: string,
      lessonDocumentId: string,
    ) => {
      const serie = slugify(serieName, { lower: true, strict: true });
      const lesson = slugify(lessonName, { lower: true, strict: true });
      return `${process.env.NEXT_PUBLIC_FRONT_END_HOST}/serie/${serie}/${serieDocumentId}/${lesson}/${lessonDocumentId}`;
    },
  },
  teacherDetails: {
    makeUrl: (teacherName: string, teacherDocumentId: string) => {
      const formattedDisplayName = slugify(teacherName, { lower: true, strict: true });
      return `${process.env.NEXT_PUBLIC_FRONT_END_HOST}/insegnante/${formattedDisplayName}/${teacherDocumentId}`;
    },
  },
};
